// MySpend.info brand tokens — single source of truth for all inline styles
export const T = {
  // ── Palette ────────────────────────────────────────────────────────────────
  navy:        '#0B1E2D',
  navyMid:     '#122535',
  navyLight:   '#1E3A4F',
  tealDeep:    '#0A7C8A',
  tealBright:  '#05C4B0',
  tealPale:    '#DFFAF7',
  amberDeep:   '#D97B28',
  amberBright: '#F2A93B',
  amberPale:   '#FEF4E3',
  slate:       '#4A6B7C',
  mist:        '#D0E6EC',
  white:       '#F7FAFA',
  appBg:       '#F2F7F9',

  // ── Gradients ──────────────────────────────────────────────────────────────
  gradTeal:  'linear-gradient(135deg, #0A7C8A 0%, #05C4B0 100%)',
  gradNavy:  'linear-gradient(160deg, #0B1E2D 0%, #122535 100%)',
  gradAmber: 'linear-gradient(135deg, #D97B28 0%, #F2A93B 100%)',

  // ── Typography ─────────────────────────────────────────────────────────────
  fontBody: "'Sora', 'DM Sans', system-ui, sans-serif",
  fontMono: "'Courier New', 'Courier', monospace",
};

// Inline style for a currency/amount display
export const amountStyle = (extra = {}) => ({
  fontFamily: T.fontMono,
  ...extra,
});

// The MySpend.info SVG logomark (28×28 render)
export function LogoMark({ size = 28 }) {
  const s = size;
  return (
    <svg width={s} height={s} viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lm-t" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0A7C8A" />
          <stop offset="100%" stopColor="#05C4B0" />
        </linearGradient>
        <linearGradient id="lm-a" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#D97B28" />
          <stop offset="100%" stopColor="#F2A93B" />
        </linearGradient>
        <clipPath id="lm-c"><circle cx="60" cy="60" r="54" /></clipPath>
      </defs>
      <circle cx="60" cy="60" r="54" fill="#122535" />
      <path d="M 18 22 C 22 30, 28 36, 36 46 C 40 52, 46 58, 52 64 C 56 68, 58 72, 60 78 C 62 84, 63 90, 64 98"
        fill="none" stroke="url(#lm-t)" strokeWidth="8" strokeLinecap="round" clipPath="url(#lm-c)" />
      <path d="M 102 22 C 96 30, 88 36, 80 46 C 74 52, 68 58, 64 64 C 61 68, 60 72, 60 78 C 60 84, 61 90, 62 98"
        fill="none" stroke="url(#lm-t)" strokeWidth="8" strokeLinecap="round" clipPath="url(#lm-c)" />
      <path d="M 60 14 C 60 22, 60 32, 60 42 C 60 52, 60 60, 60 70 C 60 78, 61 86, 62 98"
        fill="none" stroke="url(#lm-a)" strokeWidth="5.5" strokeLinecap="round" clipPath="url(#lm-c)" />
      <circle cx="63" cy="96" r="5.5" fill="#F2A93B" clipPath="url(#lm-c)" />
      <circle cx="18" cy="22" r="4" fill="#05C4B0" opacity="0.9" />
      <circle cx="60" cy="14" r="4" fill="#F2A93B" />
      <circle cx="102" cy="22" r="4" fill="#05C4B0" opacity="0.9" />
    </svg>
  );
}

// "MySpend" bold + ".info" light wordmark inline
export function Wordmark({ size = 20, lightColor = 'rgba(255,255,255,0.9)' }) {
  return (
    <span style={{ fontFamily: T.fontBody, fontSize: size, letterSpacing: -0.3, lineHeight: 1 }}>
      <span style={{ fontWeight: 700, color: lightColor }}>MySpend</span>
      <span style={{ fontWeight: 300, color: T.amberBright }}>.info</span>
    </span>
  );
}
